module.exports = "../fonts/ApercuLAPhil-Bold.woff2";


//////////////////
// WEBPACK FOOTER
// ./@fonts/apercu-laphil/ApercuLAPhil-Bold.woff2
// module id = 509
// module chunks = 7